"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryInfoSaveResponseMapper = void 0;
var DeliveryInfoSaveResponseMapper = /** @class */ (function () {
    function DeliveryInfoSaveResponseMapper(data) {
        this.localData = data;
    }
    DeliveryInfoSaveResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return DeliveryInfoSaveResponseMapper;
}());
exports.DeliveryInfoSaveResponseMapper = DeliveryInfoSaveResponseMapper;
//# sourceMappingURL=DeliveryInfoSaveResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/DeliveryInfoSaveResponseMapper.js
// module id = 2082
// module chunks = 8